'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.faqs = twentyninetimes.faqs || function () {

	function init() {
		const rankMathFaqs = document.querySelectorAll('.rank-math-list-item')

		if ( rankMathFaqs.length > 0 ) {
      rankMathFaqFunction(rankMathFaqs);
		}
	}

	function rankMathFaqFunction(rankMathFaqs) {
    rankMathFaqs.forEach((faq) => {
      var id = faq.getAttribute('id').replace('faq-question-', ''),
        question = faq.querySelector('.rank-math-question'),
        answer = faq.querySelector('.rank-math-answer'),
        answerContent = answer.innerHTML,
        questionContent = question.innerHTML;

      faq.classList.add('js-accordion');

      var questionContentNew = '<button id="faq-toggle-'+id+'" class="rank-math-list-item__toggle js-accordion-toggle" type="button" aria-expanded="false" aria-controls="faq-content-'+id+'">' + questionContent + '</button>',
          answerContentNew = '<div id="faq-content-'+id+'" class="rank-math-list-item__content js-accordion-content" aria-labelledby="faq-toggle-'+id+'" style="height: 0px;"><div class="rank-math-list-item__content-inner wysiwyg">' + answerContent + '</div></div>';

      faq.innerHTML = questionContentNew + answerContentNew;
    });
	}


	return {
		init : init
	};

}();